/**
 * Asynchronously loads the component for CrmMessageDetailsPage
 */

import { lazyLoad } from 'utils/loadable';

export const CrmMessageDetailsPage = lazyLoad(
  () => import('./index'),
  module => module.CrmMessageDetailsPage,
);
